import { useEffect, useState } from 'react';

export function fmtDuration(secs: number): string {
  const m = Math.floor(secs / 60);
  const s = Math.floor(secs % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function formatNow(): string {
  const d = new Date();
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function useNow(): string {
  const [val, setVal] = useState(() => formatNow());
  useEffect(() => {
    const id = setInterval(() => setVal(formatNow()), 1000);
    return () => clearInterval(id);
  }, []);
  return val;
}

export function useLiveDuration(initial: number): number {
  const [d, setD] = useState(initial);
  useEffect(() => {
    const startWall = performance.now();
    const startBase = initial;
    setD(initial);
    const id = setInterval(() => {
      const elapsed = (performance.now() - startWall) / 1000;
      setD(startBase + elapsed);
    }, 1000);
    return () => clearInterval(id);
  }, [initial]);
  return d;
}

export function initialsFromAssignee(name: string): string {
  return name
    .split(' ')
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('');
}

export function seriesAvgDelta(series: number[]): number {
  if (series.length < 2) return 0;
  const avg = series.slice(0, -1).reduce((s, x) => s + x, 0) / (series.length - 1);
  return series[series.length - 1]! - Math.round(avg);
}

export function seriesTailDelta(series: number[]): number {
  if (series.length < 2) return 0;
  return series[series.length - 1]! - series[series.length - 2]!;
}
